const DECIMAL_NUMBER = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/;

export function parseFiniteNumber(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const text = String(value).trim();
  if (!DECIMAL_NUMBER.test(text)) return null;
  const number = Number(text);
  return Number.isFinite(number) ? number : null;
}

export function validateStrategyNumbers(form, usesPredictionBounds) {
  const errors = {};
  const values = {
    initial_capital: parseFiniteNumber(form.initialCapital),
    min_predicted_return: null,
    max_predicted_return: null,
  };
  if (values.initial_capital === null || values.initial_capital <= 0) {
    errors.initialCapital = 'Enter capital as a number greater than 0.';
  }
  if (usesPredictionBounds) {
    for (const [field, key, label] of [
      ['minPredictedReturn', 'min_predicted_return', 'Minimum'],
      ['maxPredictedReturn', 'max_predicted_return', 'Maximum'],
    ]) {
      const raw = form[field];
      if (raw == null || (typeof raw === 'string' && raw.trim() === '')) continue;
      values[key] = parseFiniteNumber(raw);
      if (values[key] === null) errors[field] = `${label} Predicted Return must be a finite number.`;
    }
    if (values.min_predicted_return !== null && values.max_predicted_return !== null
        && values.min_predicted_return > values.max_predicted_return) {
      errors.maxPredictedReturn = 'Minimum Predicted Return must be less than or equal to Maximum Predicted Return.';
    }
  }
  return { values, errors, error: Object.values(errors)[0] || '' };
}
